import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { usePolygonContext } from 'src/contexts/polygon.context';
import { actionTypes } from 'src/ducks/polygon.duck';
import { IPolygon, IPolygonForm } from 'src/models/polygon.model';
import { getPolygonStatus } from 'src/selectors/polygon.selector';
import PolygonForm from '../polygon-form/polygon-form.component';
import style from '../polygon-list/polygon-list.module.scss';

const PolygonAdd: React.FC = () => {
  const { state, actions } = usePolygonContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues: Partial<IPolygon> = {
    polygon: '',
  };

  const addStatus = getPolygonStatus(state, actionTypes.POLYGON_ADD);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: IPolygonForm = {
        polygon: data.polygon,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_POLYGON_ADD_SUCCESS,
            formData.polygon
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_POLYGON}
      content={
        <div className={style.content}>
          <PolygonForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default PolygonAdd;
